import React, { useEffect, useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";
import { useNavigate } from "react-router-dom";
import { getTokenInternal } from "./useToken";


export default function AllJunk() {
  const [allMaps, setAllMaps] = useState([]);
  const [allMapsName, setAllMapsName] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [allTypes, setAllTypes] = useState([]);
  const [allGames, setAllGames] = useState([]);

  const [token, setToken] = useState();
const navigate = useNavigate();

  const fetchData2 = async () => {
    const token = await getTokenInternal();
    setToken(token);
    if (
      !token ||
      (token.account.role !== "management" && token.account.role !== "owner")
    ) {
      navigate("/");
      return;
    }
}

  useEffect(() => {
    fetchData2();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const urls = [
          `${process.env.REACT_APP_API_HOST}/api/maps`,
          `${process.env.REACT_APP_API_HOST}/api/maps_name`,
          `${process.env.REACT_APP_API_HOST}/api/events`,
          `${process.env.REACT_APP_API_HOST}/api/types`,
          `${process.env.REACT_APP_API_HOST}/api/games`,
        ];

        const responses = await Promise.all(urls.map((url) => fetch(url)));
        const data = await Promise.all(responses.map((res) => res.json()));

        setAllMaps(data[0]);
        setAllMapsName(data[1]);
        setAllEvents(data[2]);
        setAllTypes(data[3]);
        setAllGames(data[4]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id, endpoint) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOST}/${endpoint}/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        // If deletion is successful, remove the item from state
        switch (endpoint) {
          case 'api/maps':
            setAllMaps(allMaps.filter(map => map.id !== id));
            break;
          case 'api/maps_name':
            setAllMapsName(allMapsName.filter(mapName => mapName.id !== id));
            break;
          case 'api/events':
            setAllEvents(allEvents.filter(event => event.id !== id));
            break;
          case 'api/types':
            setAllTypes(allTypes.filter(type => type.id !== id));
            break;
          case 'api/games':
            setAllGames(allGames.filter(game => game.id !== id));
            break;
          default:
            break;
        }
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <Nav />
      <div className="container mx-auto py-8">
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">All Maps</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allMaps.map((map) => (
              <li key={map.id} className="bg-gray-800 p-4 rounded">
                {map.name}
                <button
                  className="ml-20 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDelete(map.id, "api/maps")}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">All Maps Names</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allMapsName.map((mapName) => (
              <li key={mapName.id} className="bg-gray-800 p-4 rounded">
                {mapName.name}
                <button
                  className="ml-20 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDelete(mapName.id, "api/maps_name")}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">All Events</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allEvents.map((event) => (
              <li key={event.id} className="bg-gray-800 p-4 rounded">
                {event.name}
                <button
                  className="ml-20 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDelete(event.id, "api/events")}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-2xl font-bold mb-4">All Types</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allTypes.map((type) => (
              <li key={type.id} className="bg-gray-800 p-4 rounded">
                {type.name}
                <button
                  className="ml-20 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDelete(type.id, "api/types")}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-2xl font-bold mb-4">All Games</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allGames.map((game) => (
              <li key={game.id} className="bg-gray-800 p-4 rounded">
                {game.name}
                <button
                  className="ml-20 bg-blue-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDelete(game.id, "api/games")}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
          }
